<vdr-form-field>
    <ng-container *ngIf="hasData; else emptyState">
        <div class="portfolio-summary">
            {{ totalItems }} cliente(s) na carteira
        </div>

        <div class="portfolio-table-wrapper">
            <table class="table portfolio-table">
                <thead>
                    <tr>
                        <th>Cliente</th>
                        <th>Documento</th>
                        <th>Email</th>
                        <th>Telefone</th>
                        <th>Canal</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let item of visibleItems"
                        class="portfolio-row"
                        (click)="openCustomerDetails(item.customer?.id)"
                    >
                        <td>{{ customerName(item) }}</td>
                        <td>{{ customerDocument(item) }}</td>
                        <td>{{ customerEmail(item) }}</td>
                        <td>{{ customerPhone(item) }}</td>
                        <td>{{ channelName(item) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="portfolio-pagination" *ngIf="totalItems > pageSize">
            <button
                class="btn btn-sm btn-outline"
                (click)="previousPage()"
                [disabled]="currentPage === 1"
            >
                Anterior
            </button>
            <span>Página {{ currentPage }} de {{ totalPages }}</span>
            <button
                class="btn btn-sm btn-outline"
                (click)="nextPage()"
                [disabled]="currentPage === totalPages"
            >
                Próxima
            </button>
        </div>
    </ng-container>

    <ng-template #emptyState>
        <div class="portfolio-empty">
            Este vendedor ainda não possui clientes em sua carteira.
        </div>
    </ng-template>
</vdr-form-field>
